export default __webpack_public_path__ + "static/media/icon-shinhan.1181d7bf.png";